import React from 'react';

import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const CloseActionButton = (props: IBaseActionButtonProps) => {
  const theme = useTheme();
  const { classes } = useStyles();

  return (
    <BaseActionButton
      styles={{
        color: theme.palette.grey[400],
      }}
      {...props}>
      <CloseIcon className={classes.icon} />
    </BaseActionButton>
  );
};

export default CloseActionButton;
